import HeadphoneIcon from "./../../assets/img/HeadPhone.svg"
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useQuestion } from "../../redux/Reducers/QuestionReducer";

export default function ListenAudio({ className, ...props }) {
    const { question, questionActions } = useQuestion()
    const [replaysLeft, setReplaysLeft] = useState(3)
    const audioRef = useRef();
    useEffect(() => {
        setReplaysLeft(3)
    }, [question])

    function playAudio() {
        if (!audioRef.current) {
            audioRef.current = new Audio(props?.audio)
        }
        let audio = audioRef.current;
        if (!audio.paused)
            return;
        if (replaysLeft > 0) {
            audio.play();
            setReplaysLeft(replaysLeft - 1)
        } else {
            toast.error("You have no replays left")
        }

    }

    useEffect(() => {
        if (props.replayOnce) {
            setReplaysLeft(1)
        }
    }, []);
    return (


        <>
            <div className={"items-center justify-center text-center"}>
                <button
                    className={"rounded-full bg-tertiary-100 p-5 disabled:bg-tertiary-50 disabled:cursor-not-allowed"}
                    onClick={playAudio}
                    disabled={replaysLeft === 0}

                    type="button">
                    {
                        props.showPerson ? <img className={" h-24 w-24 "} alt={""} src={HeadphoneIcon} />
                            :
                            <img className={" h-24 w-24 "} alt={""} src={HeadphoneIcon} />
                    }
                </button>
                {
                    props.replayOnce ?
                        <p>Listen Carefully! You can only ply the audio clips once</p> :
                        <p>Replays Left : {replaysLeft}</p>
                }

            </div>

            <audio className={"bg-white hidden self-center rounded-full"} controls src={props?.audio} />
        </>
    )


}
